import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@material-ui/core";
import useModalWithTextStyles from "./ModalWithTextStyle";

export interface ModalWithTextProps {
  open: boolean;
  onClose: () => void;
  content?: string;
  title?: string;
}

const ModalWithText: React.FC<ModalWithTextProps> = ({
  open,
  onClose,
  content = "",
  title = "Note",
}) => {
  const classes = useModalWithTextStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      scroll="body"
      aria-labelledby="note-dialog-title"
    >
      <DialogTitle id="note-dialog-title" disableTypography>
        <Typography className={classes.title}>{title}</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.paragraph}>{content}</Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ModalWithText;
